import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const assetsObjectTypeConfigurationRoute: InvariantJiraRoute = {
	name: 'assets-object-type-configuration',
	path: '/jira/assets/configure/object-type/:objectTypeId',
};
